module.exports = {"lang":"EN","home":"首页","distanceTime":"2022世界人工智能大会还有 {num} 天"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/languages/ch.json
// module id = ub7X
// module chunks = 20